import React from "react";
import { NavLink } from "react-router-dom";
import { Home, ClipboardList, Heart, Phone } from "lucide-react";
import { useI18n } from "@/contexts/I18nContext";
import { useFavorites } from "@/contexts/FavoritesContext";

export default function BottomNav() {
  const { t } = useI18n();
  const { ids } = useFavorites();

  const item = ({ isActive }) =>
    `flex min-w-0 flex-col items-center gap-1 rounded-xl px-1 py-2 text-[10px] font-semibold transition-all ${
      isActive ? "text-brand-orange" : "text-slate-500 hover:text-brand-navy"
    }`;

  const dot = (n) =>
    n > 0 ? (
      <span className="absolute -top-0.5 -right-1.5 min-w-4 h-4 px-1 rounded-full bg-brand-orange text-white text-[9px] font-bold flex items-center justify-center">
        {n > 9 ? "9+" : n}
      </span>
    ) : null;

  return (
    <nav
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 border-t border-slate-200/80 bg-white/95 px-2 pt-1 shadow-[0_-12px_35px_rgba(15,23,42,.10)] backdrop-blur-xl pb-safe"
      data-testid="bottom-nav"
      aria-label="Navigation principale"
    >
      <div className="grid grid-cols-4 max-w-md mx-auto items-end">
        <NavLink to="/" end className={item} data-testid="bn-home">
          <Home className="h-5 w-5" strokeWidth={2.2} />
          <span>{t("nav.home")}</span>
        </NavLink>
        <NavLink to="/demandes" className={item} data-testid="bn-requests">
          <ClipboardList className="h-5 w-5" strokeWidth={2.2} />
          <span className="truncate">Mes demandes</span>
        </NavLink>
        <NavLink to="/favoris" className={item} data-testid="bn-favorites">
          <span className="relative">
            <Heart className="h-5 w-5" strokeWidth={2.2} />
            {dot(ids.length)}
          </span>
          <span>{t("nav.favorites")}</span>
        </NavLink>
        <NavLink to="/contact" className={item} data-testid="bn-contact">
          <Phone className="h-5 w-5" strokeWidth={2.2} />
          <span>Contact</span>
        </NavLink>
      </div>
    </nav>
  );
}
